<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
	provide () {
        return {
            reload: this.reload,
            VTheme:this.VTheme,
        }
    },
    data() {
        return{
            isRouterAlive: true,
            VTheme:window.document.documentElement.getAttribute("data-theme")
        }
    },
    created(){
        if (localStorage.getItem("spaceId") ) {
           this.$store.commit('updateSpaceId',parseInt(localStorage.getItem("spaceId")))
        }
        if (localStorage.getItem("stuSpaceId") ) {
           this.$store.commit('updateStuSpaceId',parseInt(localStorage.getItem("stuSpaceId")))
        }
        if (localStorage.getItem("squareid") ) {
           this.$store.commit('updateSquareId',parseInt(localStorage.getItem("squareid")))
        }
        if (localStorage.getItem("aigc_status") ) {
           this.$store.commit('setAigc_status',localStorage.getItem("aigc_status"))
        }
    },
    methods: {
        reload () {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            })
        }
    },
    watch:{

    }

}
</script>

<style lang="scss">
@import 'assets/css/theme/_handle.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue